import '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';

const mapServerToSpecificationsBase = (serverVariant, brand)=>{
    const { erpId , opcoBackendId  } = serverVariant;
    const serverSpecifications = {
        brand,
        erpId,
        opcoBackendId
    };
    return getSpecificationItems(serverSpecifications);
};

export { mapServerToSpecificationsBase };
//# sourceMappingURL=map-server-to-specifications-base.js.map
